
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ContactInfoSection from './components/ContactInfoSection';
import ContactFormSection from './components/ContactFormSection';
import MapSection from './components/MapSection';

export default function ContactPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Suspense fallback={<div>{t('common.loading')}</div>}>
          <HeroSection />
          <ContactInfoSection />
          <ContactFormSection />
          <MapSection />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
